<template lang="pug">
  .component-backoffice-client-approval.row.column
    AccontStatusFilter(v-model="search", :statuses="['document_status','payment_method','subscription']")
    base-list(
      :component="component",
      :dataLoader="dataLoader",
      :search="search",
      componentType="client-approval-card"
    )
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import SearchInputForm from 'components/structure/ui/filters/SearchInputForm'
  import BaseList from './BaseList'
  import HeaderColumns from 'components/structure/ui/HeaderColumns'
  import AccontStatusFilter from '../../components/backoffice/tabbed/AccontStatusFilter'

  export default {
    name: 'ClientList',
    components: {
      AccontStatusFilter,
      BaseList,
      SearchInputForm,
      HeaderColumns,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Client.vue'),
        headers: [' ', 'Client Name/ID', 'Client Type', 'Address', 'Billing Address', 'Main Driver'],
        search: {
          status: 'ON HOLD',
          order_field: 'updated_at',
          sort_order: 'desc',
          query: null,
          payment_method: 0,
          document: 0,
          subscription: 0,
        }
      }
    },
    methods: {
      setSearch(search) {
        search.status = 'ON HOLD'
        this.search = search
      },
      dataLoader(callback, page, resultsPerPage, search) {
        KeplerBackofficeSdk.clients.list(page, resultsPerPage, search).approval((data) => {
          callback(data)
        })
      },
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-client-approval
    .activeIcon
      color: #64db6f
</style>



// WEBPACK FOOTER //
// ClientApprovalQueue.vue?6b96f2a6